export const LOCATION_IMPORT_STATUS = {
  PENDING: 1,
  COMPLETED: 2,
  FINISHED_WITH_PROBLEMS: 3
};
